import React from "react"

const Footer = () => {
  return (
    <div className="ft-data">
      <footer>
        <div className="ft-copy">Copyright © 2020</div>
        <a
          href="https://github.com/jp98smartins"
          rel="noreferrer"
          target="_blank"
        >
          <div className="ft-dev">Desenvolvido por João Pedro Martins</div>
        </a>
      </footer>
    </div>
  )
}

export default Footer
